import { ClerkProvider } from "@clerk/clerk-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { env } from "@/shared/config/env";
import { ToastProvider } from "@/shared/ui";
import { AuthBridge } from "./AuthBridge";

/**
 * Single QueryClient for the app. Conservative defaults — tune per-query in the
 * feature hooks, not here.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * Composition of cross-cutting providers. The ONLY place these are wired.
 * Order: auth (Clerk) → server cache (Query) → app. Theme is bootstrapped by
 * the inline script in index.html and managed by a useTheme hook (shared/lib).
 */
export function Providers({ children }: { children: ReactNode }) {
  return (
    <ClerkProvider publishableKey={env.CLERK_PUBLISHABLE_KEY} afterSignOutUrl="/">
      <QueryClientProvider client={queryClient}>
        <AuthBridge />
        <ToastProvider>{children}</ToastProvider>
      </QueryClientProvider>
    </ClerkProvider>
  );
}
